import classNames from 'classnames'
import { forwardRef } from 'react'
import type { SfCheckboxProps } from '@storefront-ui/react'

const SfCheckbox = forwardRef<HTMLInputElement, SfCheckboxProps>(
  ({ invalid, className, ...attributes }, ref ): JSX.Element => (
    <input
      className={classNames(
        `resupply-checkbox`,
        className,
        `h-[18px] min-w-[18px] border rounded-[6px] appearance-none cursor-pointer bg-white text-gray-500 enabled:hover:border-deepSleep enabled:active:border-deepSleep enabled:hover:checked:text-deepSleep enabled:hover:indeterminate:text-deepSleep enabled:active:checked:text-deepSleep enabled:checked:text-deepSleep checked:bg-checked-checkbox-current border-current indeterminate:bg-indeterminate-checkbox-current enabled:indeterminate:text-deepSleep disabled:text-gray-300 hover:text-gray-300 disabled:cursor-not-allowed enabled:focus-visible:outline enabled:focus-visible:outline-offset`,
        {
          'border-negative-700 enabled:hover:border-negative-800 enabled:active:border-negative-900':
            invalid
        }
      )}
      type="checkbox"
      ref={ref}
      data-testid="checkbox"
      {...attributes}
    />
  )
)

SfCheckbox.displayName = `SfCheckbox`

export default SfCheckbox
